const Aboutus = () => {
    return (
        <div>
            about us
        </div>
    )
}

export default Aboutus;